/* --- Desplazamiento con respaldo ----------------------------------------
   Safari no acepto la forma con objeto de `scrollTo` / `scrollIntoView` hasta
   la 15.4: en versiones anteriores la llamada se ignora y no pasa nada. Se
   comprueba el soporte una vez y, si falta, se usa la forma antigua: salta en
   seco, pero llega, que es lo que importa. */
var SUAVE_OK = 'scrollBehavior' in document.documentElement.style;

function irA(caja, izquierda) {
  if (SUAVE_OK) caja.scrollTo({ left: izquierda, behavior: 'smooth' });
  else caja.scrollLeft = izquierda;
}

function verElemento(el, bloque) {
  if (SUAVE_OK) { el.scrollIntoView({ behavior: 'smooth', block: bloque }); return; }
  var r = el.getBoundingClientRect();
  var y = r.top + window.pageYOffset;
  if (bloque === 'center') y -= (window.innerHeight - r.height) / 2;
  window.scrollTo(0, Math.max(0, y));
}

/* Strapion storefront behavior */
(function () {
  'use strict';

  function bindProductZoomBackdrop() {
    document.querySelectorAll('dialog.dialog-zoomed-gallery__dialog').forEach(function (dialog) {
      if (dialog.dataset.strapionBackdropClose) return;
      dialog.dataset.strapionBackdropClose = '1';
      var startedOnBackdrop = false;
      dialog.addEventListener('mousedown', function (event) {
        startedOnBackdrop = event.target === dialog;
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog && startedOnBackdrop) dialog.close();
        startedOnBackdrop = false;
      });
    });
  }

  function bindRevealMotion() {
    var items = document.querySelectorAll('.s-reveal:not([data-reveal-bound])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('s-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries, instance) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('s-visible');
        instance.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (item) {
      item.dataset.revealBound = '1';
      observer.observe(item);
    });
  }

  function updateHeaderState() {
    document.body.classList.toggle('s-scrolled', window.scrollY > 24);
  }

  function bindMobileMenu() {
    document.querySelectorAll('.sh-mobile-menu:not([data-menu-bound])').forEach(function (menu) {
      menu.dataset.menuBound = '1';
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { menu.removeAttribute('open'); });
      });
      document.addEventListener('click', function (event) {
        if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') menu.removeAttribute('open');
      });
    });
  }

  /* Contador del carrito en la cabecera.
     El marcado lo pinta Liquid una sola vez, asi que sin esto el numero se
     queda congelado hasta recargar la pagina. */

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-link]').forEach(function (link) {
      var bubble = link.querySelector('[data-cart-bubble]');
      if (!bubble) return;

      var previo = bubble.textContent.trim();
      link.setAttribute('aria-label', 'Cart, ' + count + ' items');
      bubble.textContent = count;

      if (count > 0) {
        bubble.removeAttribute('hidden');
      } else {
        bubble.setAttribute('hidden', '');
      }

      if (count > 0 && String(count) !== previo) {
        bubble.classList.remove('is-bumped');
        void bubble.offsetWidth; // fuerza un reflow para poder repetir la animacion
        bubble.classList.add('is-bumped');
      }
    });
  }

  function refreshCartCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () { /* si falla, el numero se queda como estaba */ });
  }

  function bindCartCount() {
    if (document.documentElement.dataset.cartCountBound) return;
    document.documentElement.dataset.cartCountBound = '1';

    // Lo dispara el tema al anadir, quitar o cambiar cantidades.
    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (!event || !event.promise) {
        refreshCartCount();
        return;
      }

      event.promise.then(function (resultado) {
        var detail = resultado && resultado.detail;

        // Si la peticion fallo, dejamos el numero anterior en vez de mentir.
        if (detail && detail.didError) return;

        // El evento trae un carrito, pero con las claves de Storefront y
        // `detail.itemCount` son las unidades anadidas, no el total. Pedimos
        // /cart.js, que es la fuente inequivoca del total.
        refreshCartCount();
      }, refreshCartCount);
    });

    // Al volver con el boton atras el navegador restaura el HTML antiguo.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshCartCount();
    });
  }

  /* Anticipo del configurador en la home.
     Cambia la foto al elegir color y actualiza el enlace para que el
     configurador abra en ese mismo color. Aqui no hay variantes ni precios:
     eso es cosa del configurador de verdad. */
  function bindHomeBuilder() {
    var swatches = document.querySelector('[data-hb-swatches]');
    if (!swatches || swatches.dataset.builderBound) return;
    swatches.dataset.builderBound = '1';

    var imagen = document.querySelector('[data-hb-imagen]');
    var etiqueta = document.querySelector('[data-hb-etiqueta]');
    var enlace = document.querySelector('[data-hb-enlace]');
    if (!imagen || !enlace) return;

    var base = enlace.getAttribute('href').split('?')[0];

    // Traerse las fotos por adelantado: sin esto el primer clic de cada color
    // parpadea mientras se descarga.
    window.setTimeout(function () {
      swatches.querySelectorAll('[data-hb-foto]').forEach(function (boton) {
        var previa = new Image();
        previa.src = boton.dataset.hbFoto;
      });
    }, 1200);

    swatches.addEventListener('click', function (evento) {
      var boton = evento.target.closest('[data-hb-color]');
      if (!boton || boton.classList.contains('is-activo')) return;

      swatches.querySelectorAll('[data-hb-color]').forEach(function (otro) {
        otro.classList.toggle('is-activo', otro === boton);
        otro.setAttribute('aria-checked', otro === boton ? 'true' : 'false');
      });

      imagen.classList.add('is-cambiando');
      var nueva = new Image();
      nueva.onload = nueva.onerror = function () {
        imagen.src = boton.dataset.hbFoto;
        imagen.alt = boton.dataset.hbNombre;
        // Reflow forzado, no requestAnimationFrame: en una pestana en segundo
        // plano rAF no corre y la foto se quedaria transparente.
        void imagen.offsetWidth;
        imagen.classList.remove('is-cambiando');
      };
      nueva.src = boton.dataset.hbFoto;

      if (etiqueta) etiqueta.textContent = boton.dataset.hbNombre;
      enlace.href = base + '?color=' + encodeURIComponent(boton.dataset.hbColor);
    });

    // Flechas dentro del grupo, como espera un radiogroup.
    swatches.addEventListener('keydown', function (evento) {
      if (evento.key !== 'ArrowLeft' && evento.key !== 'ArrowRight') return;
      var botones = Array.prototype.slice.call(swatches.querySelectorAll('[role="radio"]'));
      var i = botones.indexOf(evento.target);
      if (i < 0) return;
      evento.preventDefault();
      var siguiente = botones[(i + (evento.key === 'ArrowRight' ? 1 : botones.length - 1)) % botones.length];
      siguiente.click();
      siguiente.focus();
    });
  }

  /* Carrusel de correas de la home.
     El desplazamiento lo hace el navegador; esto solo pone flechas y puntos
     encima. Las paginas se calculan del ancho real, asi que el mismo codigo
     vale para 4, 2 o 1 tarjeta por vista sin saber nada de los cortes. */
  function bindCarousels() {
    document.querySelectorAll('[data-carrusel]:not([data-carrusel-bound])').forEach(function (raiz) {
      raiz.dataset.carruselBound = '1';

      var track = raiz.querySelector('[data-carrusel-track]');
      var nav = raiz.querySelector('[data-carrusel-nav]');
      var contenedorPuntos = raiz.querySelector('[data-carrusel-dots]');
      var anterior = raiz.querySelector('[data-carrusel-prev]');
      var siguiente = raiz.querySelector('[data-carrusel-next]');
      if (!track || !nav) return;

      function paginas() {
        return Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
      }

      function paginaActual() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }

      function pintarPuntos() {
        var total = paginas();

        if (total < 2) {
          nav.hidden = true;
          return;
        }
        nav.hidden = false;

        if (contenedorPuntos.children.length !== total) {
          contenedorPuntos.innerHTML = '';
          for (var i = 0; i < total; i++) {
            var punto = document.createElement('button');
            punto.type = 'button';
            punto.className = 's-carousel__dot';
            punto.setAttribute('role', 'tab');
            punto.setAttribute('aria-label', 'Page ' + (i + 1) + ' of ' + total);
            punto.dataset.pagina = String(i);
            contenedorPuntos.appendChild(punto);
          }
        }

        var actual = paginaActual();
        Array.prototype.forEach.call(contenedorPuntos.children, function (punto, i) {
          punto.classList.toggle('is-activo', i === actual);
          punto.setAttribute('aria-selected', i === actual ? 'true' : 'false');
        });

        // Un margen de 2px: el scroll no siempre cae en el pixel exacto.
        anterior.disabled = track.scrollLeft <= 2;
        siguiente.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      function irA(pagina) {
        irA(track, pagina * track.clientWidth);
      }

      anterior.addEventListener('click', function () { irA(paginaActual() - 1); });
      siguiente.addEventListener('click', function () { irA(paginaActual() + 1); });

      contenedorPuntos.addEventListener('click', function (evento) {
        var punto = evento.target.closest('[data-pagina]');
        if (punto) irA(Number(punto.dataset.pagina));
      });

      var pendiente;
      track.addEventListener('scroll', function () {
        window.clearTimeout(pendiente);
        pendiente = window.setTimeout(pintarPuntos, 90);
      }, { passive: true });

      window.addEventListener('resize', function () {
        window.clearTimeout(pendiente);
        pendiente = window.setTimeout(pintarPuntos, 160);
      });

      pintarPuntos();
    });
  }

  /* Aviso de reposicion: mete la variante elegida en el correo.
     El selector de variantes cambia sin recargar, asi que el valor correcto
     solo se sabe en el momento de enviar. `product-form-component` mantiene un
     input oculto llamado "id" con la variante actual: esa es la fuente. */
  function bindRestockVariant() {
    document.querySelectorAll('[data-sr-aviso]:not([data-sr-bound])').forEach(function (caja) {
      caja.dataset.srBound = '1';

      var form = caja.querySelector('form');
      var campoVariante = caja.querySelector('[data-sr-variante]');
      var campoCuerpo = caja.querySelector('[data-sr-cuerpo]');
      if (!form || !campoVariante || !campoCuerpo) return;

      var ids, titulos;
      try {
        ids = JSON.parse(caja.dataset.srVariantes);
        titulos = JSON.parse(caja.dataset.srTitulos);
      } catch (e) {
        return;
      }

      form.addEventListener('submit', function () {
        var actual = document.querySelector('input[name="id"]');
        if (!actual) return;

        var i = ids.indexOf(Number(actual.value));
        if (i < 0) return;

        campoVariante.value = titulos[i];
        campoCuerpo.value = 'RESTOCK::' + caja.dataset.srHandle + ' · ' + titulos[i];
      });
    });
  }

  /* Resenas: abrir el formulario y bajar suave al bloque desde las estrellas
     del titulo, como en Amazon. */
  function bindReviews() {
    document.querySelectorAll('[data-sr-abrir]:not([data-sr-abrir-bound])').forEach(function (boton) {
      boton.dataset.srAbrirBound = '1';
      boton.addEventListener('click', function () {
        var caja = document.querySelector('[data-sr-caja]');
        if (!caja) return;
        caja.classList.remove('is-plegada');
        caja.classList.add('is-abierta');
        var primer = caja.querySelector('input, textarea');
        verElemento(caja, 'center');
        if (primer) window.setTimeout(function () { primer.focus(); }, 400);
      });
    });

    document.querySelectorAll('[data-sr-saltar]:not([data-sr-saltar-bound])').forEach(function (enlace) {
      enlace.dataset.srSaltarBound = '1';
      enlace.addEventListener('click', function (evento) {
        var destino = document.getElementById('resenas');
        if (!destino) return;
        evento.preventDefault();
        verElemento(destino, 'start');
      });
    });

    // Si el formulario se envio, Shopify recarga con el ancla: hay que
    // desplegarlo para que se vea el mensaje de gracias.
    var caja = document.querySelector('[data-sr-caja]');
    if (caja && caja.querySelector('.sr-form__ok, .sr-form__error')) {
      caja.classList.remove('is-plegada');
      caja.classList.add('is-abierta');
    }
  }

  function boot() {
    bindProductZoomBackdrop();
    bindRevealMotion();
    bindMobileMenu();
    bindCartCount();
    bindHomeBuilder();
    bindCarousels();
    bindRestockVariant();
    bindReviews();
    updateHeaderState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('scroll', updateHeaderState, { passive: true });
  new MutationObserver(function () {
    bindProductZoomBackdrop();
    bindRevealMotion();
    bindMobileMenu();
    bindHomeBuilder();
    bindCarousels();
    bindRestockVariant();
    bindReviews();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


/* El selector de familias se ancla arriba en movil cuando el de la cabecera
   sale de pantalla. Con IntersectionObserver y no con scroll: no hay que medir
   nada en cada fotograma y aguanta cualquier alto de cabecera. */
(function () {
  'use strict';

  var barra = document.querySelector('[data-sx-switch-fijo]');
  if (!barra || !window.IntersectionObserver) return;

  // El original es el primero que no vive dentro de la propia barra.
  var original = null;
  var todos = document.querySelectorAll('.sx-switch');
  for (var i = 0; i < todos.length; i++) {
    if (!todos[i].closest('[data-sx-switch-fijo]')) { original = todos[i]; break; }
  }
  if (!original) return;

  new IntersectionObserver(function (entradas) {
    var fuera = !entradas[0].isIntersecting;
    barra.classList.toggle('is-fijo', fuera);
    barra.setAttribute('aria-hidden', fuera ? 'false' : 'true');
  }, { threshold: 0 }).observe(original);
})();


/* Los adelantos de familia muestran sus colorways solos, y tambien al pulsar
   una muestra. Las dos cosas pintan lo mismo, asi que comparten funcion.
   Las muestras siguen siendo enlaces: sin JS llevan igualmente a su destino. */
(function () {
  'use strict';

  var INTERVALO = 3200;
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SALIDA = 190;

  /* Relevo entre dos fotos. Se precarga la nueva antes de tocar nada: si se
     cambia el src en seco, el hueco se queda vacio mientras descarga y el
     relevo se convierte en un parpadeo. */
  function cambiarFoto(foto, src, alt) {
    /* Fuera el srcset: si se queda, el navegador sigue eligiendo de la lista
       vieja y la foto no cambia. */
    foto.removeAttribute('srcset');
    foto.removeAttribute('sizes');

    function poner() {
      foto.src = src;
      if (alt) foto.alt = alt;
    }

    if (quieto) { poner(); return; }

    var previa = new Image();
    previa.onload = previa.onerror = function () {
      foto.classList.add('sx-sale');

      window.setTimeout(function () {
        poner();
        foto.classList.remove('sx-sale');

        // Estado de entrada sin transicion, reflow, y ya anima hasta su sitio.
        foto.classList.add('sx-entra');
        void foto.offsetWidth;
        foto.classList.remove('sx-entra');
      }, SALIDA);
    };
    previa.src = src;
  }

  /** Lleva la tarjeta de una caja al colorway de esa muestra. */
  function aplicarVista(caja, muestra) {
    var foto = caja.querySelector('.s-product-card__image img');
    var titulo = caja.querySelector('.s-product-card__meta h3 a');
    var precio = caja.querySelector('.s-product-card__meta strong');
    if (!foto || !titulo) return;

    var src = muestra.getAttribute('data-img');
    if (src && foto.getAttribute('src') !== src) {
      cambiarFoto(foto, src, muestra.getAttribute('data-titulo'));
    }

    titulo.textContent = muestra.getAttribute('data-titulo') || titulo.textContent;
    if (precio && muestra.getAttribute('data-precio')) {
      precio.textContent = muestra.getAttribute('data-precio');
    }

    // La tarjeta pasa a apuntar al colorway que se esta viendo.
    var destino = muestra.getAttribute('href');
    if (destino) {
      var enlaces = caja.querySelectorAll('.s-product-card__image, .s-product-card__meta h3 a');
      Array.prototype.forEach.call(enlaces, function (a) { a.setAttribute('href', destino); });
    }

    var hermanas = caja.querySelectorAll('[data-sx-vista]');
    Array.prototype.forEach.call(hermanas, function (m) { m.classList.remove('is-activa'); });
    muestra.classList.add('is-activa');
  }

  /* --- clic: manda el visitante ---------------------------------------- */

  document.addEventListener('click', function (evento) {
    var muestra = evento.target.closest && evento.target.closest('[data-sx-vista]');
    if (!muestra) return;

    var caja = muestra.closest('.sc-familia__caja');
    if (!caja) return;

    evento.preventDefault();

    // Si ha elegido a mano, el giro automatico se calla y no le lleva la contraria.
    if (caja.sxDetener) caja.sxDetener();
    aplicarVista(caja, muestra);
  });

  /* --- giro automatico -------------------------------------------------- */

  function girar(caja) {
    /* Solo giran los colorways. Los adelantos por diseno (miniaturas) se
       quedan quietos: ahi cada foto es un producto distinto y no una version
       del mismo, asi que el cambio automatico se lee como que la tarjeta se
       equivoca de producto, no como un colorway girando. */
    if (caja.querySelector('.sc-familia__mini')) return;

    var muestras = Array.prototype.slice.call(caja.querySelectorAll('[data-sx-vista]'));
    if (muestras.length < 2) return;

    var i = 0;
    var reloj = null;
    var ala_vista = false;
    var detenido = false;

    function paso() {
      i = (i + 1) % muestras.length;
      aplicarVista(caja, muestras[i]);
    }

    function arrancar() {
      if (reloj || detenido || document.hidden) return;
      reloj = window.setInterval(paso, INTERVALO);
    }

    function parar() {
      if (!reloj) return;
      window.clearInterval(reloj);
      reloj = null;
    }

    caja.sxDetener = function () { detenido = true; parar(); };

    /* Solo gira lo que se esta viendo: fuera de pantalla no aporta nada y
       deja al navegador descargando fotos que nadie mira. */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entradas) {
        ala_vista = entradas[0].isIntersecting;
        if (ala_vista) arrancar(); else parar();
      }, { threshold: 0.35 }).observe(caja);
    } else {
      ala_vista = true;
      arrancar();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar(); else if (ala_vista) arrancar();
    });

    // Con el raton encima se para: quien mira una foto no quiere que se le vaya.
    caja.addEventListener('mouseenter', parar);
    caja.addEventListener('mouseleave', function () { if (ala_vista) arrancar(); });
  }

  if (!quieto) {
    Array.prototype.forEach.call(document.querySelectorAll('.sc-familia__caja'), girar);
  }
})();


/* --- Barra de compra fija en movil --------------------------------------
   El configurador es una columna larga: foto, color, frame, cantidad y solo
   entonces el precio. En movil eso son 2,6 pantallas antes de saber cuanto
   cuesta. La barra no duplica logica: refleja el precio que ya calcula el
   configurador y su boton pulsa el de verdad, asi que packs, validaciones y
   avisos siguen pasando por el mismo sitio. */
(function () {
  'use strict';

  // El del modal de compra rapida no cuenta: ahi no se hace scroll de pagina.
  var botones = document.querySelectorAll('[data-sx-add]');
  var real = null;
  for (var i = 0; i < botones.length; i++) {
    if (!botones[i].closest('.quick-add-modal, dialog')) { real = botones[i]; break; }
  }
  if (!real) return;

  var panel = real.closest('[data-configurador]') || document;
  var precio = panel.querySelector('[data-sx-precio]');
  if (!precio) return;

  var valorColor = panel.querySelector('[data-sx-valor="design"]') || panel.querySelector('[data-sx-valor="color"]');
  var valorFrame = panel.querySelector('[data-sx-valor="model"]');

  var barra = document.createElement('div');
  barra.className = 'sx-barra';
  barra.innerHTML =
    '<div class="sx-barra__datos">' +
      '<strong class="sx-barra__precio"></strong>' +
      '<span class="sx-barra__resumen"></span>' +
    '</div>' +
    '<button type="button" class="sx-barra__boton"></button>';
  document.body.appendChild(barra);

  var elPrecio = barra.querySelector('.sx-barra__precio');
  var elResumen = barra.querySelector('.sx-barra__resumen');
  var elBoton = barra.querySelector('.sx-barra__boton');

  function refrescar() {
    elPrecio.textContent = precio.textContent.trim();
    elBoton.textContent = real.textContent.trim();
    elBoton.disabled = real.disabled;

    var partes = [];
    if (valorColor && valorColor.textContent.trim()) partes.push(valorColor.textContent.trim());
    if (valorFrame && valorFrame.textContent.trim()) partes.push(valorFrame.textContent.trim());
    elResumen.textContent = partes.join(' · ');
  }

  refrescar();

  /* Se escucha el panel en vez de recalcular: cualquier cosa que cambie el
     precio —color, frame, tramo, mezcla— pasa por ahi. */
  if (window.MutationObserver) {
    new MutationObserver(refrescar).observe(panel, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['disabled', 'class']
    });
  }

  elBoton.addEventListener('click', function () {
    real.click();
  });

  /* Solo aparece cuando el boton de verdad no se ve: teniendolo delante, la
     barra seria un segundo boton compitiendo con el mismo. */
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (entradas) {
      barra.classList.toggle('is-visible', !entradas[0].isIntersecting);
    }, { threshold: 0 }).observe(real);
  }
})();


/* La zona fijada tiene un solo tamano. Hubo una version que la encogia al
   pasar el selector de frames, y se quito: cambiar de alto mueve el contenido,
   y ese movimiento es lo que decide si hay que cambiar de alto, asi que el
   estado se disparaba en bucle. Con scroll real, continuo y con inercia, ni la
   histeresis ni la compensacion lo evitaban. */


/* --- Carrito: barra de pack, agrupacion, titulos y precio unico ----------
   Cuatro arreglos sobre el carrito nativo de Horizon, sin tocar sus plantillas.

   Funciona a la vez en la PAGINA `/cart` y en el CAJON lateral, porque los dos
   pintan el mismo snippet y comparten contenedor: `.cart-items__wrapper`. Se
   recorren todos los que haya en el documento, no uno solo — con el cajon
   abierto sobre la pagina del carrito existen los dos.

   El cajon es lo que de verdad ve el cliente: al anadir desde el configurador
   se abre encima, y ahi es donde se decide si sigue hasta la caja.

   1. El descuento de pack solo aparecia cuando YA estaba ganado, como una
      linea dentro del subtotal. Con una unidad nadie sabia que anadiendo otra
      se lleva un 10%. Ahora hay una barra que dice a cuanto estas del tramo.
   2. Las correas de un pack se leen como un lote, no como productos sueltos
      que casualmente llevan descuento.
   3. El titulo trae el sufijo "— Nylon for WHOOP 5.0" en las 42 referencias.
   4. Con cantidad 1 el precio salia dos veces con el mismo numero. */
(function () {
  'use strict';

  var pendiente = false;

  function dinero(centavos) {
    return '$' + (centavos / 100).toFixed(2);
  }

  /* Una sola regla para todo el sufijo: vale para "— Nylon for WHOOP 5.0",
     "— Breathable Nylon...", "— Special Edition..." y "— Leather...". */
  function acortar(t) {
    return t
      .replace(/\s*[—–-]\s*[^—–-]*for\s+WHOOP\s*5\.0\s*$/i, '')
      .replace(/^Strapion\s+/i, '');
  }

  function limpiarTitulos() {
    var sitios = '.cart-items__title,' +
      ' product-card a.user-select-text .text-block p,' +
      ' product-card .product-grid-view-zoom-out--details h3';

    document.querySelectorAll(sitios).forEach(function (a) {
      if (a.dataset.sxCorto) return;
      var t = (a.textContent || '').trim();
      var corto = acortar(t);
      if (!corto || corto === t) return;
      if (!a.getAttribute('aria-label')) a.setAttribute('aria-label', t);
      a.textContent = corto;
      a.dataset.sxCorto = '1';
    });
  }

  /* El precio de linea ya esta en la columna de la derecha. El unitario solo
     aporta algo cuando hay mas de una unidad de esa linea. */
  function precioUnico() {
    document.querySelectorAll('.cart-items__table-row').forEach(function (fila) {
      // La primera fila es la cabecera de la tabla, sin precio ni cantidad.
      if (!fila.querySelector('.cart-items__unit-price-wrapper')) return;
      var campo = fila.querySelector('input[name="updates[]"], .quantity-selector input');
      var cant = campo ? Number(campo.value || campo.getAttribute('value') || 1) : 1;
      fila.classList.toggle('sx-linea--una', cant <= 1);
    });
  }

  function textoDe(cant, ahorro) {
    if (cant >= 3) {
      return {
        titulo: 'Trio pack unlocked — 15% off',
        pie: ahorro > 0 ? 'You are saving ' + dinero(ahorro) : 'Biggest discount applied.'
      };
    }
    if (cant === 2) {
      return {
        titulo: 'Duo pack unlocked — 10% off',
        pie: 'Add 1 more band and save 15% instead.'
      };
    }
    return {
      titulo: 'Add 1 more band — save 10%',
      pie: 'Any colorways you like. The discount applies on its own.'
    };
  }

  function pintarBarra(envoltorio, cant, ahorro) {
    var caja = envoltorio.previousElementSibling;
    if (!caja || !caja.classList.contains('sx-pack')) {
      caja = document.createElement('div');
      caja.className = 'sx-pack';
      envoltorio.parentNode.insertBefore(caja, envoltorio);
    }

    var t = textoDe(cant, ahorro);
    var hechos = Math.min(cant, 3);

    var pasos = '';
    for (var i = 1; i <= 3; i++) {
      pasos += '<span class="sx-pack__paso' + (i <= hechos ? ' is-hecho' : '') + '">' + i + '</span>';
    }

    caja.className = 'sx-pack' + (cant >= 3 ? ' sx-pack--tope' : '') + (cant >= 2 ? ' sx-pack--activo' : '');
    caja.innerHTML =
      '<div class="sx-pack__cab">' +
        '<strong class="sx-pack__titulo">' + t.titulo + '</strong>' +
        (ahorro > 0 ? '<span class="sx-pack__ahorro">−' + dinero(ahorro) + '</span>' : '') +
      '</div>' +
      '<div class="sx-pack__barra"><i style="width:' + (hechos / 3 * 100) + '%"></i></div>' +
      '<div class="sx-pack__pasos">' + pasos + '</div>' +
      '<p class="sx-pack__pie">' + t.pie + '</p>';
  }

  function agrupar(envoltorio, cant, ahorro) {
    var tramo = null;
    if (cant >= 3) tramo = 'Trio pack';
    else if (cant === 2) tramo = 'Duo pack';

    var tira = envoltorio.querySelector('.sx-grupo');

    if (!tramo) {
      envoltorio.classList.remove('is-pack');
      if (tira) tira.remove();
      return;
    }

    envoltorio.classList.add('is-pack');

    if (!tira) {
      tira = document.createElement('div');
      tira.className = 'sx-grupo';
      envoltorio.insertBefore(tira, envoltorio.firstChild);
    }

    tira.innerHTML =
      '<span class="sx-grupo__nombre">' + tramo + '</span>' +
      '<span class="sx-grupo__detalle">' + cant + ' bands together</span>' +
      (ahorro > 0 ? '<span class="sx-grupo__ahorro">−' + dinero(ahorro) + '</span>' : '');
  }

  function pintar(carrito) {
    var cant = carrito.item_count;
    var ahorro = carrito.original_total_price - carrito.total_price;

    /* Puede haber dos a la vez: el de la pagina y el del cajon abierto encima. */
    document.querySelectorAll('.cart-items__wrapper').forEach(function (envoltorio) {
      var barra = envoltorio.previousElementSibling;

      if (!cant) {
        if (barra && barra.classList.contains('sx-pack')) barra.remove();
        envoltorio.classList.remove('is-pack');
        var t = envoltorio.querySelector('.sx-grupo');
        if (t) t.remove();
        return;
      }

      pintarBarra(envoltorio, cant, ahorro);
      agrupar(envoltorio, cant, ahorro);
    });
  }

  function refrescar() {
    if (pendiente) return;
    pendiente = true;

    window.requestAnimationFrame(function () {
      pendiente = false;
      limpiarTitulos();
      precioUnico();

      window.fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(pintar)
        .catch(function () { /* sin red, la pagina sigue siendo usable */ });
    });
  }

  /* Horizon rehace la lista al cambiar una cantidad, y el cajon se reemplaza
     de golpe al anadir, asi que no valen los oyentes sobre botones concretos.
     Se vigila el documento y se ignora lo que cambia dentro de lo que pinta
     este mismo modulo, que si no se realimenta. */
  new MutationObserver(function (cambios) {
    for (var i = 0; i < cambios.length; i++) {
      var n = cambios[i].target;
      if (n.nodeType === 1 && (n.closest('.sx-pack') || n.closest('.sx-grupo'))) continue;
      refrescar();
      return;
    }
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:cart:lines-update', refrescar);

  refrescar();
})();
